import React from 'react';
import './Help.scss';
import { ReactComponent as Expan } from '../../assets/images/arrowHead.svg';
import PlainNavbar from '../../components/plainNavbarWithoutButtons/plainNavbarWithoutButtons';

import InfoImage from 'assets/images/info.svg';
import PhoneBookImage from 'assets/images/addressBook.svg';
import phoneImage from 'assets/images/phone.svg';
import PopupFrame from 'layouts/PopupFrame';

export const Help: React.FC = () => {
  interface IhelpItem {
    title: string;
    description: string;
    image: string;
  }

  const helpItems: IhelpItem[] = [
    // {
    //   title: '자주묻는 질문',
    //   description: '자주 묻는 질문을 확인하세요',
    //   image: InfoImage,
    // },

    // {
    //   title: '기능 가이드',
    //   description: '샵솔 기능을 확인해보세요',
    //   image: PhoneBookImage,
    // },
    {
      title: '고객센터',
      description: '1:1로 문제를 바로 해결하세요',
      image: InfoImage,
      // image: phoneImage,
    },
  ];

  const connectKakaoChat = () => {
    window.open('http://gw1dv.channel.io/');
  };

  return (
    <div className="helpScreen">
      <PopupFrame>
        <div className="helpContainer">
          <div className="header">도움말</div>

          {helpItems.map((item: IhelpItem) => {
            return (
              <div className="helpItem" key={item.title} onClick={connectKakaoChat}>
                <div className="leftContainer">
                  <div className="imageContainer">
                    <img src={item.image} alt="" />
                  </div>
                  <div className="textContainer">
                    <div className="title">{item.title}</div>
                    <div className="subTitle">{item.description}</div>
                  </div>
                </div>

                <div className="arrow">
                  <Expan />
                </div>
              </div>
            );
          })}
        </div>
      </PopupFrame>
    </div>
  );
};
